import { FC } from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from './types';

const RakbankLogoIcon: FC<SVGIconType> = ({ size = 35 }) => {
  const containerClasses = css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  });

  return (
    <div
      data-testid="bp-logo-icon"
      className={containerClasses}
      style={{ width: size, height: 'auto' }}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 35 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>Rakbank</title>
        <g clipPath="url(#clip0_24003_3793)">
          <path
            d="M18.1716 24.6869C18.1716 24.6869 0.499988 24.0597 0.0107895 34.5077C-0.00197212 34.7757 0.214976 34.9988 0.482969 34.9988H24.1757C24.429 34.9988 24.6734 34.9596 24.9026 34.8872L30.5976 24.6864H18.1716V24.6869Z"
            fill="#9D1200"
          />
          <path
            d="M25.4293 0.350709C25.0568 0.120527 24.6271 0 24.1899 0H0.472653C0.211749 0 0 0.211749 0 0.472653V12.4284C0 12.6317 0.130452 12.8113 0.322823 12.8765C9.5963 16.0069 17.7505 21.9812 22.7176 30.6558C23.4933 32.0105 24.1918 33.4313 24.8044 34.9173C25.0228 34.8587 25.2288 34.7703 25.4179 34.6569C25.4345 34.6465 25.451 34.636 25.4675 34.6257C31.1895 31.0723 35 24.7316 35 17.5005C35 10.2694 31.1729 3.89939 25.4293 0.350709Z"
            fill="#FF2E00"
          />
        </g>
        <defs>
          <clipPath id="clip0_24003_3793">
            <rect width="35" height="35" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export { RakbankLogoIcon };
